// src/hooks/useMapboxToken.js
import { MAPBOX_ACCESS_TOKEN } from '../config/constants';

const useMapboxToken = () => {
  return MAPBOX_ACCESS_TOKEN;
};

export default useMapboxToken;